export default {
  message: 'A valid date range is required.',
  fn: (value) => value && value.length === 2 && value[0] && value[1]
};
